module.exports = __webpack_public_path__ + "static/restaurant1-e92a8d25d700eaf30c8b30ed41a4f36d.jpg";